import api from "./api.ts"

export const fetchAllSubscriptions = async (token: string) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_DB_URI}/users/subscription/`)
        return response
    } catch (err) {
        return err
    }
}

export const buySubscription = async (token: string, planId: string) => {
    const data = new FormData();
    data.append('subscription_id', planId)
    try {
        const response = await api.post(`${process.env.REACT_APP_DB_URI}/users/user-subscription/purchase/`, data)
        return response;
    } catch (err) {
        return err
    }
}

export const fetchActiveSubscriptions = async (token: string) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_DB_URI}/users/subscription/active/?type=ORGANIZATION`)
        return response
    } catch (err) {
        return err
    }
}

export const fetchActiveInfluencerSubscriptions = async (token: string) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_DB_URI}/users/subscription/active/?type=INFLUENCER`)
        return response
    } catch (err) {
        return err
    }
}

export const fetchMyeSubscriptions = async (token: string) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_DB_URI}/users/user-subscription/my-subscriptions/`)
        return response
    } catch (err) {
        return err
    }
}

export const verifypayment = async (token: string, verificationData: any) => {
    try {
        const response = await api.post(`${process.env.REACT_APP_DB_URI}/users/user-subscription/verify-payment/`, verificationData)
        return response;
    } catch (err) {
        return err
    }
}

export const deleteSubs = async (token: string, id: string) => {
    try {
        const response = await api.delete(`${process.env.REACT_APP_DB_URI}/users/subscription/${id}`)
        return response;
    } catch (err) {
        return err
    }
}

export const GetSubsInfo = async (token: string, type: string, status: string) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_DB_URI}/users/user-subscription/by-type/?type=${type}&status=${status}`)
        return response;
    } catch (err) {
        return err
    }
}

export const GetNotifications = async (token: string, id: string) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_DB_URI}/notification/?user_id=${id}`)
        return response;
    } catch (err) {
        return err
    }
}

export const GetNotificationsUnread = async (token: string) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_DB_URI}/notification/unseen_notifications/`)
        return response;
    } catch (err) {
        return err
    }
}

export const MarkAllSeen = async (token: string) => {
    try {
        const response = await api.patch(`${process.env.REACT_APP_DB_URI}/notification/mark_all_as_seen/`, {})
        return response;
    } catch (err) {
        return err
    }
}

export const MarkAsRead = async (token: string, notificationId: number) => {
    try {
        const response = await api.patch(`${process.env.REACT_APP_DB_URI}/notification/${notificationId}/mark_as_seen/`, {})
        return response;
    } catch (err) {
        return err
    }
}

export const getLocationByPinCode = async (pin: string) => {
    try {
        const response = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
        const data = await response.json();

        if (data[0].Status === "Success") {
            const po = data[0].PostOffice[0];
            console.log("District:", po.District);
            console.log("State:", po.State);
            console.log("city", po.Block);

            return {
                status: data[0].Status,
                district: po.District,
                state: po.State,
                city: po.Block || po.Name, // fallback if Block is null
            };
        } else {
            console.error("Invalid pincode");
            return null;
        }
    } catch (error) {
        console.error("Error fetching location by pincode:", error);
        return null;
    }
};

export const influencerCampaingnsRequest = async (token: string, userId: string) => {
    const response = await api.get(
        `${process.env.REACT_APP_DB_URI}/campaign-request/get_campaign_requests_by_user/?user_id=${userId}`
    );
    return response;
};


export const fetchCampaignSharesByUser = async (token: string, userId: string) => {
    try {
        const response = await api.get(`${process.env.REACT_APP_DB_URI}/campaign-share/by-user/?user_id=${userId}`);
        return response;
    } catch (err) {
        return err;
    }
};

export const postCampaignShare = async (token: string, data: {
    campaign: string;
    user: number;
    task_completed: boolean;
    post_link: object;
}) => {
    const formData = new FormData();
    formData.append('campaign', data.campaign);
    formData.append('user', data.user.toString());
    formData.append('task_completed', data.task_completed.toString());
    formData.append('post_link', JSON.stringify(data.post_link));

    try {
        const response = await api.post(`${process.env.REACT_APP_DB_URI}/campaign-share/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response;
    } catch (err) {
        return err;
    }
};

export const fetchUserWallet = async (token: string, userId: string) => {
    try {
        const response = await api.get(
            `${process.env.REACT_APP_DB_URI}/wallet/by-user/${userId}/`,
            {
                headers: {
                    "accept": "application/json",
                }
            }
        );
        return response;
    } catch (err) {
        return err;
    }
};

export const validateCoupon = async (token: string, data: { code: string; amount: number }) => {
    try {
        const response = await api.post(`${process.env.REACT_APP_DB_URI}/users/coupons/validate/`, data);
        return response;
    } catch (err) {
        return err;
    }
};

export const createOrder = async (token: string, data: any) => {
    try {
        const response = await api.post(`${process.env.REACT_APP_DB_URI}/users/order/`, data);
        return response;
    } catch (err) {
        return err;
    }
};
